import { ENITTY } from "../../utils/constants";
import { getPathPrefix } from "../../utils/helper";
import { SMARTVIEW_TYPE_MAPPING_LABELS } from "../../utils/widgetHelper";

export const handleListItemClick = (entityDetails, config, smartviewsConfig) => {
  const entity = config?.entity?.id;
  let newUrl = new URL(window.location.href);

  if (entity === ENITTY.TASKS && entityDetails?.userTaskAutoId) {
    newUrl = createUrlForTasks(newUrl, entityDetails);
  }

  else if (entity === ENITTY.SMARTVIEWS) {
    const tabId = config?.smartViewTab?.id;
    const matchedTab = smartviewsConfig?.tabs?.find(tab => tab.id === tabId);

    if (matchedTab?.type === SMARTVIEW_TYPE_MAPPING_LABELS["TASKS"]) {
      newUrl = createUrlForTasks(newUrl, entityDetails);
    }

    else if (matchedTab?.type === SMARTVIEW_TYPE_MAPPING_LABELS["LEADS"]) {
      newUrl = createUrlForLeads(newUrl, entityDetails);
    }

    else if (matchedTab?.type === SMARTVIEW_TYPE_MAPPING_LABELS["OPPORTUNITY"]) {
      newUrl = createUrlForOpportunites(newUrl, entityDetails);
    }
  }

  window.open(newUrl.toString(), "_blank");
};

const createUrlForTasks = (url, entityDetails) => {
  url.pathname = getPathPrefix("Tasks");
  url.searchParams.set("activeTab", "manage-tasks");
  url.searchParams.set("taskAutoId", entityDetails?.userTaskAutoId);
  url.searchParams.set("leadType", entityDetails?.relatedEntity?.relatedEntityType);
  return url;
}

const createUrlForLeads = (url, entityDetails) => {
  url.pathname = `${getPathPrefix("Lead")}/LeadDetails`;
  url.searchParams.set("LeadID", entityDetails?.leadId);
  return url;
}

const createUrlForOpportunites = (url, entityDetails) => {
  url.pathname = `${getPathPrefix("Opportunity")}/OpportunityDetails`;
  url.searchParams.set("activeTab", "Tasks");
  url.searchParams.set("opportunityId", entityDetails?.prospectActivityId);
  url.searchParams.set("opportunityEvent", entityDetails?.activityEvent);
  return url;
}